<template>
  <header class="header">
    <slot name="header" />
  </header>
  <main class="main">
    <slot name="main" />
  </main>
</template>
